import { utf16Length, IsoTimestampSchema } from "./string-validation"
import { z } from "zod"

export const PATIENT_DEACTIVATION_REQUEST_STATUSES = [
	"pending",
	"approved",
	"rejected",
	"cancelled",
	"reactivated",
] as const

export const PatientDeactivationRequestStatusSchema = z.enum(
	PATIENT_DEACTIVATION_REQUEST_STATUSES,
).meta({ id: "PatientDeactivationRequestStatus" })
export type PatientDeactivationRequestStatus = z.infer<typeof PatientDeactivationRequestStatusSchema>

export const CreatePatientDeactivationRequestSchema = z.object({
	reason: z.string().trim().min(1).apply(utf16Length("max", 1_000)),
	confirmationUniversalPatientId: z.uuid(),
}).meta({ id: "CreatePatientDeactivationRequest" })
export type CreatePatientDeactivationRequest = z.infer<typeof CreatePatientDeactivationRequestSchema>

export const PatientDeactivationImpactSchema = z.object({
	orderCount: z.number().int().nonnegative(),
	ticketCount: z.number().int().nonnegative(),
}).meta({ id: "PatientDeactivationImpact" })
export type PatientDeactivationImpact = z.infer<typeof PatientDeactivationImpactSchema>

export const PatientDeactivationRequestSchema = z.object({
	id: z.uuid(),
	patientProfileId: z.uuid(),
	patientUserId: z.uuid(),
	requestedByUserId: z.uuid(),
	decidedByUserId: z.uuid().nullable(),
	reason: z.string(),
	status: PatientDeactivationRequestStatusSchema,
	requestedAt: IsoTimestampSchema,
	decidedAt: IsoTimestampSchema.nullable(),
	reactivatedAt: IsoTimestampSchema.nullable(),
	userWasDisabledBeforeApproval: z.boolean().nullable(),
	impact: PatientDeactivationImpactSchema,
}).meta({ id: "PatientDeactivationRequest" })
export type PatientDeactivationRequest = z.infer<typeof PatientDeactivationRequestSchema>

export const PatientDeactivationRequestResponseSchema = z.object({
	request: PatientDeactivationRequestSchema,
}).meta({ id: "PatientDeactivationRequestResponse" })
export type PatientDeactivationRequestResponse = z.infer<typeof PatientDeactivationRequestResponseSchema>
